import { Command } from 'ckeditor5';
import { findByInstanceId } from './utils';
export const INSERT_PLACEHOLDER_COMMAND = 'insertPlaceholder';
export const SET_PLACEHOLDER_REF_COMMAND = 'setPlaceholderRef';
export const RENAME_PLACEHOLDER_REF_COMMAND = 'renamePlaceholderRef';
export const REMOVE_PLACEHOLDER_COMMAND = 'removePlaceholder';
export class RemovePlaceholderCommand extends Command {
    execute(options) {
        const { instanceId } = options;
        const { model } = this.editor;
        const element = findByInstanceId(model, instanceId);
        if (!element) {
            return;
        }
        model.change((writer) => {
            writer.remove(element);
        });
    }
}
